<template>
    <div>
        <div class="buttons-container">
            <StandardButton
                v-if="!isSellersManagement"
                :icon-name="'arrow_back'"
                title="Voltar"
                :text="'Voltar'"
                :action="
                    () => {
                        close();
                    }
                "
            />
        </div>
        <cc-loader v-if="loading" />
        <div v-if="!loading" class="page-table-modal-products">
            <div class="page-table-content">
                <div class="page-table-header">
                    <div class="page-table-header-text status-width">
                        Status
                    </div>
                    <div class="page-table-header-text client-width">
                        Cliente
                    </div>
                </div>
                <div
                    v-for="(prod, idx) in filteredProducts"
                    :key="prod.id"
                    :class="getSpecialBackground(idx)"
                >
                    <div class="page-table-row">
                        <div class="page-table-desc-column status-width">
                            <span
                                v-show="prod.last_offer_price > 0"
                                style="color: #20ce88"
                                class="material-icons-outlined"
                            >
                                done
                            </span>
                        </div>
                        <div class="page-table-desc-column client-width">
                            {{ prod.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RequestService from "@/services/v2/requests.service";
import RequestServiceV3 from "@/services/v3/request.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import StandardButton from "@/components/ui/buttons/Standard-Button.vue";

export default {
    components: {
        StandardButton,
    },
    mixins: [loaderMixin],
    props: [
        "request_id",
        "seller_id",
        "show_offered_products",
        "closeOffersPartial",
        "isSellersManagement",
        "for_id",
    ],
    data() {
        return {
            page: 1,
            items_by_page_value: 10,
            loading: false,
            svc: new RequestService(),
            v3_svc: new RequestServiceV3(),
            products: [],
            filters: {
                attending: true,
            },
            total_items: 0,
        };
    },
    computed: {
        filteredProducts() {
            if (!this.show_offered_products) {
                return this.products;
            }
            return this.products.filter((prod) => prod.last_offer_price > 0);
        },
    },
    mounted() {
        this.load_products();
    },
    methods: {
        close() {
            this.$emit("close");
        },
        getSpecialBackground(idx) {
            if (idx % 2 != 0) return "page-table-line-special";
        },
        load_products(page = this.page) {
            this.loading = true;
            this.page = page;
            const params = { seller_id: this.seller_id, load_derivatives: 0 };
            return this.v3_svc
                .request_products(this.request_id, params)
                .then((response) => response.data)
                .then((data) => {
                    this.products = data;
                    this.v3_svc
                        .last_offers(this.request_id, { for_id: this.for_id })
                        .then((response) => response.data)
                        .then((data) => {
                            this.loading = false;
                            this.products
                                .filter((p) => p && !p.is_generic)
                                .forEach(
                                    (p) =>
                                        (p.derivatives = [
                                            { ...p, main_product: p },
                                        ])
                                );
                            this.products.forEach((p) => {
                                this.process_last_offer(p, data);
                            });
                            this.$forceUpdate();
                        });
                })
                .catch((err) => {
                    ErrorHandlerService.handle(err, this.$store);
                });
        },
        process_last_offer(prod, offers) {
            offers.forEach((offer) => {
                if (prod.id == offer.main_product_id) {
                    prod.last_offer_price =
                        prod.previous_offer || offer.last_offer;
                }
                prod.derivatives.forEach((deriv) => {
                    if (deriv.id == offer.product_id && offer.last_offer > 0) {
                        prod.last_offer_price =
                            deriv.previous_offer || offer.last_offer;
                        deriv.last_offer_price =
                            deriv.previous_offer || offer.last_offer;
                    }
                });
            });
        },
    },
};
</script>
<style lang="scss">
@import "@/sass/commons/_variables";

.check {
    text-align: center;

    i {
        color: #4267b2;
    }
}

.page-table-modal-products {
    margin: 1.2em;
    max-height: 70vh;
    overflow: auto;
}

.page-table-header {
    background: #fffefc;
    border: 0.5px solid #e5e5e5;
    font-weight: 400;
    color: #605f5f;
    display: flex;
    padding: 1em 0em;
}

.page-table-header-text {
    padding-left: 10px;
    font-weight: 600;
    font-size: 1rem;
    color: #505050;
}

.page-table-row {
    display: flex;
    font-weight: 300;
    font-size: 0.8rem;
    color: #605f5f;
    align-items: center;
}

.page-table-desc-column {
    padding: 0.5em 0.7em;
    text-align: left;
}

.page-table-line-special {
    background: #f7f7f7;
}

.buttons-container {
    padding: 1em 1.2em;
    display: flex;
    flex-direction: row-reverse;
}

.status-width {
    width: 10%;
}

.client-width {
    width: 90%;
}
</style>
